import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=5a332122&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=5a332122&prod&scoped=true&lang=css&"
import style1 from "./DashboardView.vue?vue&type=style&index=1&id=5a332122&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a332122",
  null
  
)

export default component.exports